// extracted by mini-css-extract-plugin
export default {"modalWrapper":"styles_modalWrapper__bLwMV","modalContents":"styles_modalContents__THKWx"};